import React, { useState } from 'react';
import './Suduko.css';

const sudokuGames = [
  [
    [5, 3, '', '', 7, '', '', '', ''],
    [6, '', '', 1, 9, 5, '', '', ''],
    ['', 9, 8, '', '', '', '', 6, ''],
    [8, '', '', '', 6, '', '', '', 3],
    [4, '', '', 8, '', 3, '', '', 1],
    [7, '', '', '', 2, '', '', '', 6],
    ['', 6, '', '', '', '', 2, 8, ''],
    ['', '', '', 4, 1, 9, '', '', 5],
    ['', '', '', '', 8, '', '', 7, 9],
  ],
  [
    ['', '', '', 2, 6, '', 7, '', 1],
    [6, 8, '', '', 7, '', '', 9, ''],
    [1, 9, '', '', '', 4, 5, '', ''],
    [8, 2, '', 1, '', '', '', 4, ''],
    ['', '', 4, 6, '', 2, 9, '', ''],
    ['', 5, '', '', '', 3, '', 2, 8],
    ['', '', 9, 3, '', '', '', 7, 4],
    ['', 4, '', '', 5, '', '', 3, 6],
    [7, '', 3, '', 1, 8, '', '', ''],
  ],
  // Add 8 more puzzles here...
];

const Suduko = () => {
  const [gameIndex, setGameIndex] = useState(0);
  const [board, setBoard] = useState([...sudokuGames[gameIndex]]);
  const [originalBoard, setOriginalBoard] = useState([...sudokuGames[gameIndex]]);

  const handleChange = (e, rowIndex, colIndex) => {
    const updatedBoard = board.map((row, rIdx) =>
      row.map((cell, cIdx) => (rIdx === rowIndex && cIdx === colIndex ? e.target.value : cell))
    );
    setBoard(updatedBoard);
  };

  const isValid = (board, row, col, num) => {
    for (let x = 0; x < 9; x++) {
      if (board[row][x] === num || board[x][col] === num) {
        return false;
      }
    }

    const startRow = row - (row % 3), startCol = col - (col % 3);
    for (let i = 0; i < 3; i++) {
      for (let j = 0; j < 3; j++) {
        if (board[i + startRow][j + startCol] === num) {
          return false;
        }
      }
    }
    return true;
  };

  const solveSudoku = (board) => {
    for (let row = 0; row < 9; row++) {
      for (let col = 0; col < 9; col++) {
        if (board[row][col] === '') {
          for (let num = 1; num <= 9; num++) {
            if (isValid(board, row, col, num)) {
              board[row][col] = num;
              if (solveSudoku(board)) {
                return true;
              }
              board[row][col] = '';
            }
          }
          return false;
        }
      }
    }
    return true;
  };

  const clearBoard = () => {
   // setBoard([...originalBoard]);
   window.location.reload();
  };

  const checkSolution = () => {
    const solvedBoard = JSON.parse(JSON.stringify(board));
    if (solveSudoku(solvedBoard)) {
      alert('The solution is correct!');
    } else {
      alert('The solution is incorrect!');
    }
  };

  const newGame = () => {
    const nextIndex = (gameIndex + 1) % sudokuGames.length;
    setGameIndex(nextIndex);
    setBoard([...sudokuGames[nextIndex]]);
    setOriginalBoard([...sudokuGames[nextIndex]]);
  };

  const completeGame = () => {
    const solvedBoard = [...board];
    solveSudoku(solvedBoard);
    setBoard(solvedBoard);
  };

  return (
    <div className="Appsudu">
      <h1>Sudoku Game</h1>
      <div className="boardSuduko">
        {board.map((row, rowIndex) => (
          <div key={rowIndex} className="rowSuduko">
            {row.map((cell, colIndex) => (
              <input
                key={colIndex}
                type="text"
                maxLength="1"
                value={cell}
                onChange={(e) => handleChange(e, rowIndex, colIndex)}
                className="cellSuduko"
              />
            ))}
          </div>
        ))}
      </div>
      <div className="button-container">
        <button onClick={clearBoard}>Clear</button>
        {/* <button onClick={checkSolution}>Check Solution</button> */}
        <button onClick={newGame}>New Game</button>
        <button onClick={completeGame}>Complete</button>
      </div>
    </div>
  );
};

export default Suduko;